<script>
  import { onMount, createEventDispatcher, afterUpdate } from "svelte";
  import { Child, ChildChunks,DefaultChildChunks, RelationshipOptions } from "./store.js";
  import * as objectWrapper from "../Utils/ObjectWrapper.js";
  import Field from "../FormField.svelte";
  import * as Validator from "../Utils/ValidateFormFIelds.js";
  import Select from "../HTMLElements/Select.svelte";
  import TextBox from "../HTMLElements/Textbox.svelte";
  import CheckBox from "../HTMLElements/CheckBoxInput.svelte";
  import { GetChild } from "./service.js";
  import wrappedFetch from '../../wrappedfetch.js';

  const dispatch = new createEventDispatcher();

  export let id;  
  export let applicationId;

  let selectedRelationship, firstNameInput;
  let isFormValid = true;
  let error = '';
  let wrappedObj;
  let isDetailsChanged = false;
  let isSaveAndExit = false;

export let applications =[];
export let lateApplications =[];
let showApplicationResubmit =false;

  export const saveAndExit = async () => {
    isSaveAndExit = true;
    await validateAndSave();
    if (isFormValid && !showApplicationResubmit) {dispatch("pageChange", '/user/home');}
  }
  $:{
    if(wrappedObj && wrappedObj.scSkip.value)
    {
      wrappedObj.scForename.value = '';
      wrappedObj.scSurname.value = '';
      wrappedObj.scRelationship.value = '';
    }
    }

  onMount(async () => {
    
    if (!$Child || !id) await GetChild(id);
   
     if(!$Child.relationship){
      dispatch('pageChange', `/application/currentschool/${id}/${applicationId}`);
    }


    ChildChunks.set({
      secondContact: {
        id:$Child.id,
        scForename: $Child.scForename,
        scSurname: $Child.scSurname,
        scRelationship: $Child.scRelationship,
        scSkip:$Child.scSkip
      }
    });
    DefaultChildChunks.set($ChildChunks);
    wrappedObj = objectWrapper.wrapObject($ChildChunks.secondContact);    
  });


   async function saveChild() {
    const saveChildURL = "child/savechildsecondcontactdetails"; 
    const resp = await wrappedFetch(saveChildURL, {
      method: "post",
      body: JSON.stringify($ChildChunks.secondContact),
      headers: {
        "Content-Type": "application/json"
      }
    });

    return await resp.json();
  }

  const validateAndSave =async () => {
    isFormValid = true;  
    if(wrappedObj && wrappedObj.scForename.value !="" && wrappedObj.scSurname.value!="" && wrappedObj.scRelationship.value != "")
         wrappedObj.scSkip.value = false;
        ChildChunks.set({ secondContact: objectWrapper.unwrapObject(wrappedObj)});       
        //Check if anything changed before doing anything else 
        $DefaultChildChunks.secondContact.scForename =  $DefaultChildChunks.secondContact.scForename  == null ? "" :  $DefaultChildChunks.secondContact.scForename;
        $DefaultChildChunks.secondContact.scSurname =  $DefaultChildChunks.secondContact.scSurname  == null ? "" :  $DefaultChildChunks.secondContact.scSurname;
        $DefaultChildChunks.secondContact.scRelationship =  $DefaultChildChunks.secondContact.scRelationship  == null ? "" :  $DefaultChildChunks.secondContact.scRelationship;
        isDetailsChanged = !(JSON.stringify($ChildChunks) === JSON.stringify($DefaultChildChunks));

       if(!isDetailsChanged)
       {
         if(isSaveAndExit)
            dispatch("pageChange", '/user/home');
         else
            dispatch("pageChange", `/application/childsummary/${id}/${applicationId}`);     
         return;
       }



    if (!Validator.validate(wrappedObj)) {
      isFormValid = false;
      error = "Please tick the box above, if you do not want to complete the required fields.";
      wrappedObj = wrappedObj;
      return;
    }


    let childResp = await saveChild();   
      if (childResp.success) {   
           Child.set(childResp.child);
      applications=childResp.applications || [];
      lateApplications = childResp.lateApplications || [];
       //if(isSaveAndExit)
     // dispatch("notification","Details changed successfully!!");
      if(applications.length > 0 || lateApplications.length > 0)
      {
        if(!$Child.isSibling){
          showApplicationResubmit = true;
          dispatch('showApplicationResubmitModal',isSaveAndExit ?'/user/home' :`/application/childsummary/${id}/${applicationId}`);
        }   
      }
      }
  };

  const saveAndNavigate = async () => {
    await validateAndSave();
    if (isFormValid && !showApplicationResubmit ) dispatch("pageChange", `/application/childsummary/${id}/${applicationId}`);
  }
</script>

<div class="step-4-shows">
  <div class="field">
    <a href="#" on:click|preventDefault={()=> {dispatch('back', `/application/relationdetails/${id}/${applicationId}`)}}>
      <span class="fas fa-arrow-left" />
      Back
    </a>
  </div>
     <div style="display:inline-flex" >
 <h1 class="title is-3">Second contact (optional)</h1>
 <span name="infoIcon" class="icon helpicon"  on:click={() => {  dispatch('showContextualHelpModal')}}><!--Help26-->
 <span class="fas fa-info-circle"></span>
 </span>
 </div>
 <h2 class="subtitle">This person will be able to act on your behalf regarding this application.</h2>
{#if wrappedObj}
  <Field label="First Name" isRequired={ wrappedObj.scSkip.value ? false : true} >
    <span slot="inputField">
      <TextBox
        placeholder="First Name"
        isRequired={ wrappedObj.scSkip.value ? 'false' : 'true'}
        bind:this={firstNameInput}
        bind:text={wrappedObj.scForename.value}
        bind:isValid={wrappedObj.scForename.isValid}
        bind:isDirty={wrappedObj.scForename.isDirty}
        label="the second contact's first name"
        disabled={wrappedObj.scSkip.value ? true : null} />
    </span>
  </Field>

  <Field label="Last Name" isRequired={ wrappedObj.scSkip.value ? false : true}>
    <span slot="inputField">
      <TextBox
        placeholder="Last Name"
        isRequired={ wrappedObj.scSkip.value ? 'false' : 'true'}
        bind:text={wrappedObj.scSurname.value}
        bind:isValid={wrappedObj.scSurname.isValid}
        bind:isDirty={wrappedObj.scSurname.isDirty}
        label="the second contact's last name"
        disabled={wrappedObj.scSkip.value ? true : null}  />
    </span>
  </Field>

  <Field label="Relationship to Child"  isRequired={ !wrappedObj.scSkip.value}>
    <span slot="inputField">
      <Select
        items={RelationshipOptions}
        bind:selectedValue={wrappedObj.scRelationship.value}
        placeholder="Select a relationship" 
        label="relationship"
        selectedValueText="value"
        isRequired={ !wrappedObj.scSkip.value}
        bind:isValid={wrappedObj.scRelationship.isValid}
        bind:isDirty={wrappedObj.scRelationship.isDirty}
        disabled={wrappedObj.scSkip.value ? true : null} 
        />
    </span>
  </Field>
  <br />
  <strong>If you do not wish to enter a second contact for this application, then please tick the box below.</strong>
  <CheckBox     
      label="I do not wish to enter a second contact"
      bind:checked={wrappedObj.scSkip.value} />
  <hr />
  {#if !isFormValid}
    <div class="notification is-invalid">
      <p>{error}</p>
    </div>
  {/if}
  <div>
    <button class="button is-primary" on:click={saveAndNavigate}>
      Save and continue
    </button>
  </div>
{/if}
</div>
